/**
 * Voyager vector basemap
 *
 * @example <caption>Use Voyager vector basemap.</caption>
 * const map = new mapboxgl.Map({
 *   container: 'map',
 *   style: carto.basemaps.voyager
 * })
 *
 * @example <caption>Use Voyager vector basemap. (String)</caption>
 * const map = new mapboxgl.Map({
 *   container: 'map',
 *   style: carto.basemaps.voyager
 * })
 *
 * @memberof carto.basemaps
 * @name voyager
 * @api
 */
export const voyager = 'https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json';

/**
 * Dark-Matter vector basemap
 *
 * @example <caption>Use Dark-Matter vector basemap.</caption>
 * const map = new mapboxgl.Map({
 *   container: 'map',
 *   style: carto.basemaps.darkmatter
 * })
 *
 * @example <caption>Use Dark-Matter vector basemap. (String)</caption>
 * const map = new mapboxgl.Map({
 *   container: 'map',
 *   style: carto.basemaps.darkmatter
 * })
 *
 * @memberof carto.basemaps
 * @name darkmatter
 * @api
 */
export const darkmatter = 'https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json';

/**
 * Positron vector basemap
 *
 * @example <caption>Use Positron vector basemap.</caption>
 * const map = new mapboxgl.Map({
 *   container: 'map',
 *   style: carto.basemaps.positron
 * })
 *
 * @example <caption>Use Positron vector basemap. (String)</caption>
 * const map = new mapboxgl.Map({
 *   container: 'map',
 *   style: carto.basemaps.positron
 * })
 *
 * @memberof carto.basemaps
 * @name positron
 * @api
 */
export const positron = 'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json';
